import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Cancel} from '@material-ui/icons';
import {T} from 'Actions/translate';
import util from 'Utils/commonUtil';

class LabelInput extends Component {
    state = {
        focus: false,
    };

    componentWillReceiveProps(nextProps) {
        // if(this.input) {
        //     if(nextProps.title !== this.props.title || nextProps.defaultValue !== this.props.defaultValue) {
        //         this.input.value = nextProps.defaultValue;
        //     }
        // }
    }

    clearInput = () => {
        // this.input.value = '';

        this.props.inputValid(this.props.title, '');
    };

    foucusInput = () => {
        this.setState({
            focus: true,
        });

        if (util.isFunction(this.props.blurFoucus)) {
            this.props.blurFoucus();
        }
    };

    blurAction = () => {
        setTimeout(() => {
            this.setState({
                focus: false,
            });
            if (util.isFunction(this.props.blurAction)) {
                this.props.blurAction();
            }
        }, 50);
    };

    inputValid = (title) => (event) => {
        let empty = true;
        if (!event.target.value && this.props.required) {
            empty = false;
        }
        this.setState({
            emptyValidation: empty,
        });
        this.props.inputValid(title, event.target.value);
    };

    render() {
        const {
            title,
            placeholder,
            type,
            defaultValue,
            testid,
            showRequiredMark,
        } = this.props;
        const {focus} = this.state;

        return (
            <div className="label-input">
                {showRequiredMark ? (
                    <span className="input-required-mark">*</span>
                ) : null}
                <label className="input-title">{T(title)}</label>
                <input
                    className="input-content"
                    onChange={this.inputValid(title)}
                    placeholder={T(placeholder)}
                    type={type || 'text'}
                    testid={testid ? testid : ''}
                    onBlur={this.blurAction}
                    onFocus={this.foucusInput}
                    value={defaultValue}
                />
                {this.input && this.input.value && focus ? (
                    <div>
                        <Cancel
                            className="cancel-button"
                            onClick={this.clearInput}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}

LabelInput.propTypes = {
    title: PropTypes.string.isRequired,
    showRequiredMark: PropTypes.bool,
};

export default LabelInput;
